import React, { useState, useEffect, useRef } from "react";
import PromptWriter from "./PromptWriter";
import { IoSaveOutline, IoCopyOutline } from "react-icons/io5";
import { useToast } from "../common/ToastContext";

const TemplateEditor = ({ path, initialValue }) => {
  const [value, setValue] = useState(initialValue);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const editorRef = useRef(null);
  const { showToast } = useToast();

  useEffect(() => {
    setValue(initialValue);
    setHasUnsavedChanges(false);
  }, [initialValue]);

  const handleChange = (newValue) => {
    setValue(newValue);
    setHasUnsavedChanges(true);
  };

  const handleSave = () => {
    window.dispatchEvent(
      new CustomEvent("saveTemplate", {
        detail: {
          path: path,
          value: value,
        },
      })
    );
    setHasUnsavedChanges(false);
    showToast("Template saved");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    showToast("Template copied to clipboard");
  };

  return (
    <div className="flex flex-col h-full" ref={editorRef}>
      <div className="flex justify-start space-x-2 px-5 pb-0">
        <button
          onClick={handleSave}
          className={`p-2 pb-0 rounded-md ${
            hasUnsavedChanges
              ? "text-blue-400 hover:text-blue-300"
              : "text-gray-600"
          }`}
          title="Save"
          disabled={!hasUnsavedChanges}
        >
          <IoSaveOutline size={20} />
        </button>
        <button
          onClick={handleCopy}
          className="text-gray-400 hover:text-gray-300 p-2 pb-0 rounded-md"
          title="Copy to clipboard"
        >
          <IoCopyOutline size={20} />
        </button>
      </div>
      <div className="flex-grow">
        <PromptWriter
          value={value}
          onChange={handleChange}
          language="jinja"
          readOnly={false}
        />
      </div>
    </div>
  );
};

export default TemplateEditor;
